export default "__VITE_ASSET__1ad0ed45__"